import { CanMatchFn, Route, UrlSegment } from '@angular/router';

import { isGradeSlug } from '@/shared/utils/curriculum/curriculum';

/**
 * Fences a route whose path carries a grade slug param (`:grade`, `:year`) so it only matches real
 * grades. A bare param route matches *any* segment: without this, `/not-found`, `/teacher/<typo>`
 * and every mistyped URL were captured by `:grade` and rendered an empty student layout, leaving the
 * wildcard 404 route unreachable for one- and two-segment URLs.
 *
 * `canMatch` — not `canActivate` — is what makes the router keep looking: a rejected match falls
 * through to the next route and ends at the wildcard, so the visitor sees the 404 page on the URL
 * they typed instead of a redirect.
 */
export function gradeSlugGuard(param: 'grade' | 'year'): CanMatchFn {
  return (route: Route, segments: UrlSegment[]) => {
    const position = (route.path ?? '').split('/').indexOf(`:${param}`);
    return position >= 0 && isGradeSlug(segments[position]?.path);
  };
}
